import JumbotronComponent from './Jumbotron.vue';
export const Jumbotron = JumbotronComponent;
export default Jumbotron;
